<template>
  <div class="animated fadeIn worksheet">
    <div class="card">
      <div class="main-card-body">
        <el-form
          ref="myFormSearch"
          label-position="left"
          @submit.native.prevent
          label-width="120px"
          :model="mData.tableRules.dataSearch.value"
          :rules="mData.tableRules.dataSearch.valid"
        >
          <div class="salary-company-toolbar-section">
            <div class="salary-company-header">
              <div class="salary-company-header__main">
                <h4 class="salary-company-header__title bold">Bảng lương công ty</h4>
                <div class="salary-company-header__period">
                  <el-select
                    v-model="selected_salary_period_id"
                    @change="fn_search"
                    filterable
                    class="salary_period"
                    placeholder="Chọn kỳ lương"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listSalaryPeriod"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="salary-company-status">
                  <span class="salary-company-status__label">Trạng thái:</span>
                  <span
                    class="salary-company-status__value"
                    :class="isPayrollSealed ? 'salary-company-status__value--sealed' : 'salary-company-status__value--open'"
                  >
                    {{ payrollStatusText }}
                  </span>
                </div>
              </div>

              <div class="button-div">
                <el-button
                  type="primary"
                  round
                  class="btn-default"
                  :disabled="!selected_salary_period_id || isPayrollSealed"
                  @click="confirmSealCompanyPayroll"
                >
                  Chốt bảng lương
                </el-button>
                <el-button
                  type="primary"
                  round
                  plain
                  class="btn-default"
                  @click="toggleSearchBox"
                >
                  Ẩn/hiện tìm kiếm
                </el-button>
                <div ref="displayColumnTrigger" class="salary-display-column-trigger">
                  <el-button
                    type="primary"
                    round
                    class="btn-default"
                    @click="toggleDisplayColumnSelector"
                  >
                    Dữ liệu hiển thị
                  </el-button>
                  <div
                    v-if="showDisplayColumnSelector"
                    class="salary-display-column-dropdown"
                  >
                    <div class="salary-display-column-panel-wrap">
                      <div class="salary-display-column-panel">
                        <el-checkbox-group
                          v-model="displaySalaryCompanyColumns"
                          class="salary-display-column-panel__group"
                          @change="handleDisplayColumnSelectionChange"
                        >
                          <el-checkbox
                            v-for="item in salaryCompanyDisplayColumnOptions"
                            :key="item.value"
                            :label="item.value"
                            class="salary-display-column-panel__item"
                          >
                            {{ item.label }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
                <el-button
                  type="primary"
                  round
                  class="btn-default"
                  @click="openExportDialog"
                >
                  Xuất bảng lương <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </div>

            <div class="main-body-search">
              <b-collapse :visible="showSearchBox" id="salaryCompanySearchPanel">
                <div class="main-body-search__content">
                  <b-row class="salary-company-search-row">
                    <b-col lg="4" md="6" cols="12" class="salary-company-search-col">
                      <el-form-item label="Công ty">
                        <el-select
                          v-model="search_company_id"
                          @change="fn_handleCompanyFilterChange"
                          filterable
                          clearable
                          class="salary_period salary-company-filter-select--all-placeholder"
                          placeholder="Tất cả công ty"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listCompany"
                            :key="item.id"
                            :label="getCompanyName(item)"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" cols="12" class="salary-company-search-col">
                      <el-form-item label="Phòng ban">
                        <el-select
                          v-model="search_department_ids"
                          multiple
                          filterable
                          clearable
                          collapse-tags
                          class="salary_period salary-company-filter-select--all-placeholder"
                          placeholder="Tất cả phòng ban"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listDepartment"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" cols="12" class="salary-company-search-col">
                      <el-form-item label="Chi nhánh">
                        <el-select
                          v-model="search_branch_ids"
                          multiple
                          filterable
                          clearable
                          collapse-tags
                          class="salary_period salary-company-filter-select--all-placeholder"
                          placeholder="Tất cả chi nhánh"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listBranch"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="salary-company-search-row">
                    <b-col lg="4" md="6" cols="12" class="salary-company-search-col">
                      <el-form-item
                        label="Trạng thái"
                        label-width="120px"
                        style="white-space: nowrap"
                      >
                        <el-select
                          v-model="search_employee_status"
                          clearable
                          class="salary_period"
                          placeholder="Tất cả trạng thái"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiLamViec"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" cols="12" class="salary-company-search-col">
                      <el-form-item
                        label="Loại hợp đồng"
                        label-width="120px"
                        class="salary-company-contract-type-form-item"
                      >
                        <el-select
                          v-model="search_contract_type_ids"
                          multiple
                          filterable
                          clearable
                          collapse-tags
                          class="salary_period salary-company-filter-select--all-placeholder salary-company-contract-type-select"
                          placeholder="Tất cả loại hợp đồng"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listContractType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="10" md="10" sm="9" cols="12">
                      <el-form-item label="Điều kiện">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.condition"
                          placeholder="Nhập Mã nhân viên, Họ và tên, Số điện thoại, Số CMND/CCCD"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col lg="2" md="2" sm="3" cols="12">
                      <div class="text-center">
                        <el-button
                          class="btn-default w-100"
                          round
                          native-type="submit"
                          type="primary"
                          @click="fn_search()"
                        >
                          Tìm kiếm
                        </el-button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>
          </div>
        </el-form>

        <div class="main-body mt-3">
          <div class="main-body-table mt-2">
            <el-table
              ref="salaryCompanyMainTable"
              :data="mData.tableRules.data"
              border
              style="width: 100%"
              class="salary-company-table"
              height="700"
              :header-cell-style="fn_getHeaderCellStyle"
              :cell-style="fn_getSalaryCompanyMainCellStyle"
            >
              <template v-for="section in salaryCompanyMainSections">
                <el-table-column
                  v-if="section.children"
                  :key="section.key + '_main_parent'"
                  :label="section.label"
                  :align="section.align || 'center'"
                >
                  <el-table-column
                    v-for="child in section.children"
                    :key="child.key"
                    :prop="child.key"
                    :label="child.label"
                    :min-width="child.minWidth"
                    :align="child.align || 'left'"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-if="isEditableSalaryCompanyColumn(child, scope.row)"
                        :value="getEditableSalaryCompanyInputValue(scope.row, child)"
                        size="mini"
                        class="salary-company-edit-input"
                        @focus="rememberEditableSalaryCompanyFieldValue(scope.row, child)"
                        @input="handleEditableSalaryCompanyInput(scope.row, child, $event)"
                        @blur="saveEditableSalaryCompanyField(scope.row, child)"
                        @keyup.enter.native="$event.target.blur()"
                      ></el-input>
                      <span v-else>{{ formatSalaryCompanyMainValue(scope.row, child, scope.$index) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  v-else
                  :key="section.key + '_main_single'"
                  :prop="section.key"
                  :label="section.label"
                  :min-width="section.minWidth"
                  :align="section.align || 'left'"
                  :fixed="section.fixed || false"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="isEditableSalaryCompanyColumn(section, scope.row)"
                      :value="getEditableSalaryCompanyInputValue(scope.row, section)"
                      size="mini"
                      class="salary-company-edit-input"
                      @focus="rememberEditableSalaryCompanyFieldValue(scope.row, section)"
                      @input="handleEditableSalaryCompanyInput(scope.row, section, $event)"
                      @blur="saveEditableSalaryCompanyField(scope.row, section)"
                      @keyup.enter.native="$event.target.blur()"
                    ></el-input>
                    <span v-else>{{ formatSalaryCompanyMainValue(scope.row, section, scope.$index) }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>

        <Loading v-if="loading" />

        <el-dialog
          title="Xuất bảng lương công ty"
          :visible.sync="syncDialogExport"
          width="540px"
          custom-class="salary-export-dialog"
        >
          <div class="salary-export-layout">
            <div class="salary-export-settings">
              <el-form
                label-width="128px"
                @submit.native.prevent
                class="salary-export-form"
              >
                <el-form-item label="Dữ liệu xuất" class="salary-export-form-item--center">
                  <el-select
                    v-model="exportConfig.report_selection_mode"
                    class="export-report-select"
                    placeholder="Chọn kiểu dữ liệu xuất"
                  >
                    <el-option label="Tất cả" value="all"></el-option>
                    <el-option label="Tùy chỉnh" value="custom"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  v-if="exportConfig.report_selection_mode === 'custom'"
                  label=""
                  class="salary-export-form-item--center salary-export-form-item--sub"
                >
                  <el-select
                    v-model="exportConfig.report_types"
                    multiple
                    collapse-tags
                    filterable
                    clearable
                    class="export-report-select"
                    :placeholder="exportConfig.report_types.length ? '' : 'Chọn dữ liệu xuất'"
                  >
                    <el-option
                      v-for="item in reportOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Định dạng file" class="salary-export-form-item--center">
                  <el-radio-group v-model="exportConfig.format">
                    <el-radio label="excel">Excel</el-radio>
                    <!-- <el-radio label="word">Word</el-radio> -->
                  </el-radio-group>
                </el-form-item>

                <!-- <el-form-item
                  v-if="exportConfig.format === 'word'"
                  label="Hướng giấy"
                  class="salary-export-form-item--center"
                >
                  <el-radio-group v-model="exportConfig.word_orientation">
                    <el-radio label="landscape">Ngang</el-radio>
                    <el-radio label="portrait">Dọc</el-radio>
                  </el-radio-group>
                </el-form-item> -->

                <el-form-item label="Phạm vi áp dụng">
                  <span class="export-hint">
                    Xuất theo bộ lọc hiện tại trên màn hình bảng lương công ty.
                  </span>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <span slot="footer" class="salary-export-footer">
            <el-button round @click="syncDialogExport = false">
              Hủy
            </el-button>
            <el-button
              type="primary"
              round
              class="btn-default"
              @click="confirmExport"
            >
              Xuất file
            </el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "../../../../service/DataService";
import MethodService from "../../../../service/MethodService";
import Loading from "../../../../component/Loading";
import BranchApi from "../../../../moduleApi/BranchApi";
import CompanyApi from "../../../../moduleApi/CompanyApi";
import ContractTypeApi from "../../../../moduleApi/ContractTypeApi";
import DepartmentApi from "../../../../moduleApi/DepartmentApi";
import PositionApi from "../../../../moduleApi/PositionApi";
import SalaryApi from "../../../../moduleApi/SalaryApi";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";
import SalaryModel from "../SalaryModel";

function createEmptyPayrollExportSource() {
  return {
    salaryList: [],
    taxList: [],
    insuranceList: [],
  };
}

const SALARY_COMPANY_DISPLAY_COLUMNS_STORAGE_KEY = "salaryCompanyVisibleColumns";
const SALARY_COMPANY_EDITABLE_COLUMN_KEYS = ["bonus", "advance_amount", "reduction_other"];
const SALARY_COMPANY_EDITABLE_FIELD_ALIASES = {
  bonus: ["bonus", "Thưởng", "Thưởng tháng", "Bonus"],
  advance_amount: ["advance_amount", "Tạm ứng", "Advance"],
  reduction_other: ["reduction_other", "Khoản giảm trừ khác", "Khác", "Khoản khác", "Reduction other"],
};

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      showSearchBox: false,
      showDisplayColumnSelector: false,
      syncDialogExport: false,
      visibleSalaryCompanyColumns: [],
      displaySalaryCompanyColumns: [],
      salaryCompanyTableLayoutTimer: null,
      displayColumnApplyTimer: null,
      reportOptions: [
        { value: "salary_company", label: "Bảng lương công ty" },
        { value: "salary_data", label: "Dữ liệu lương" },
        { value: "tax_data", label: "Dữ liệu thuế" },
        { value: "insurance_data", label: "Dữ liệu bảo hiểm" },
      ],
      salaryCompanyDisplayColumnOptions: [
        { value: "position_name", label: "Chức vụ" },
        { value: "branch_name", label: "Chi nhánh" },
        { value: "department_name", label: "Phòng ban" },
        { value: "contract_type_name", label: "Loại hợp đồng" },
        { value: "standard_work", label: "Ngày công trong tháng" },
        { value: "actual_work", label: "Số công làm việc thực tế" },
        { value: "meal_allowance_day", label: "Ngày tính ăn trưa" },
        { value: "ot_150", label: "Số giờ làm thêm 150%" },
        { value: "ot_200", label: "Số giờ làm thêm 200%" },
        { value: "ot_300", label: "Số giờ làm thêm 300%" },
        { value: "paid_leave", label: "Nghỉ phép có lương" },
        { value: "unpaid_leave", label: "Nghỉ không lương" },
        { value: "salary_level", label: "Mức lương" },
        { value: "insurance_salary", label: "Lương đóng bảo hiểm" },
        { value: "salary_income", label: "Lương" },
        { value: "ot_income", label: "OT" },
        { value: "meal_allowance", label: "Ăn trưa" },
        { value: "bonus", label: "Thưởng" },
        { value: "dependent_person", label: "Số người phụ thuộc" },
        { value: "taxable_income", label: "Thu nhập tính thuế TNCN" },
        { value: "insurance_total", label: "BHXH" },
        { value: "tax_amount", label: "Thuế TNCN" },
        { value: "meal_deduction", label: "Khấu trừ tiền ăn" },
        { value: "advance_amount", label: "Tạm ứng" },
        { value: "reduction_other", label: "Khoản giảm trừ khác" },
        { value: "total_income", label: "Tổng lương thực nhận" },
      ],
      exportConfig: {
        report_selection_mode: "all",
        format: "excel",
        word_orientation: "landscape",
        report_types: ["salary_company"],
      },
      search_company_id: undefined,
      search_department_ids: [],
      search_branch_ids: [],
      search_contract_type_ids: [],
      search_employee_status: "DANG_LAM_VIEC",
      selected_salary_period_id: undefined,
      payrollStatus: {
        isSealed: false,
        sealedStatus: "NEW",
      },
      mData: {
        moduleName: "SalaryCompany",
        tableRules: MethodService.copyObject(SalaryModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listCompany: [],
          listBranch: [],
          listDepartment: [],
          listPosition: [],
          listContractType: [],
          listTrangThaiLamViec: DataService.listTrangThaiLamViec,
          listSalaryPeriod: [],
          currentCompanyInfo: MethodService.getCompanyInfo(),
        },
        exportSource: {
          ...createEmptyPayrollExportSource(),
        },
      },
    };
  },

  created() {
    if (!this.mData.tableRules.dataSearch.value) {
      this.$set(this.mData.tableRules.dataSearch, "value", {});
    }
    if (this.mData.tableRules.dataSearch.value.condition === undefined) {
      this.$set(this.mData.tableRules.dataSearch.value, "condition", "");
    }
    const defaultDisplayColumns = this.getDefaultSalaryCompanyDisplayColumns();
    const savedDisplayColumns = this.getSavedSalaryCompanyDisplayColumns(defaultDisplayColumns);
    this.visibleSalaryCompanyColumns = [...savedDisplayColumns];
    this.displaySalaryCompanyColumns = [...savedDisplayColumns];
  },

  computed: {
    allSalaryCompanyDisplayColumnKeys() {
      return this.salaryCompanyDisplayColumnOptions.map((item) => item.value);
    },

    currentSalaryCompanyExportColumnKeys() {
      return ["stt", "employee_name", ...(this.visibleSalaryCompanyColumns || [])];
    },

    isPayrollSealed() {
      return this.payrollStatus && this.payrollStatus.isSealed === true;
    },

    payrollStatusText() {
      return this.isPayrollSealed ? "Đã chốt" : "Chưa chốt";
    },

    salaryCompanyMainSections() {
      const selectedColumnSet = new Set([
        "stt",
        "employee_name",
        ...(this.visibleSalaryCompanyColumns || []),
      ]);
      const sections = [
        {
          key: "stt",
          label: "STT",
          minWidth: 50,
          align: "center",
          fixed: "left",
        },
        {
          key: "employee_name",
          label: "Họ và tên",
          minWidth: 160,
          fixed: "left",
        },
        {
          key: "position_name",
          label: "Chức vụ",
          minWidth: 120,
        },
        {
          key: "contract_type_name",
          label: "Loại hợp đồng",
          minWidth: 220,
        },
        {
          key: "branch_name",
          label: "Chi nhánh",
          minWidth: 150,
        },
        {
          key: "department_name",
          label: "Phòng ban",
          minWidth: 200,
        },
        {
          key: "attendance",
          label: "Ngày công",
          align: "center",
          children: [
            { key: "standard_work", label: "Ngày công trong tháng", minWidth: 100, align: "center", format: "number" },
            { key: "actual_work", label: "Số công làm việc thực tế", minWidth: 100, align: "center", format: "number" },
            { key: "meal_allowance_day", label: "Ngày tính ăn trưa", minWidth: 100, align: "center", format: "number" },
            { key: "ot_150", label: "Số giờ làm thêm 150%", minWidth: 120, align: "center", format: "number" },
            { key: "ot_200", label: "Số giờ làm thêm 200%", minWidth: 120, align: "center", format: "number" },
            { key: "ot_300", label: "Số giờ làm thêm 300%", minWidth: 120, align: "center", format: "number" },
            { key: "paid_leave", label: "Nghỉ phép có lương", minWidth: 100, align: "center", format: "number" },
            { key: "unpaid_leave", label: "Nghỉ không lương", minWidth: 100, align: "center", format: "number" },
          ],
        },
        {
          key: "dependent_person",
          label: "Số người phụ thuộc",
          minWidth: 100,
          align: "center",
          format: "number",
        },
        {
          key: "salary_level",
          label: "Mức lương",
          minWidth: 100,
          align: "right",
          format: "currency",
        },
        {
          key: "insurance_salary",
          label: "Lương đóng bảo hiểm",
          minWidth: 100,
          align: "right",
          format: "currency",
        },
        {
          key: "income",
          label: "Chi tiết thu nhập",
          align: "center",
          children: [
            { key: "salary_income", label: "Lương", minWidth: 100, align: "right", format: "currency" },
            { key: "ot_income", label: "OT", minWidth: 100, align: "right", format: "currency" },
            { key: "meal_allowance", label: "Ăn trưa", minWidth: 100, align: "right", format: "currency" },
            { key: "bonus", label: "Thưởng", minWidth: 140, align: "center", format: "currency", editable: true },
          ],
        },
        {
          key: "taxable_income",
          label: "Thu nhập tính thuế TNCN",
          minWidth: 100,
          align: "right",
          format: "currency",
        },
        {
          key: "deduction",
          label: "Các khoản giảm trừ",
          align: "center",
          children: [
            { key: "insurance_total", label: "BHXH", minWidth: 100, align: "right", format: "currency" },
            { key: "tax_amount", label: "Thuế TNCN", minWidth: 100, align: "right", format: "currency" },
            { key: "meal_deduction", label: "Khấu trừ tiền ăn", minWidth: 150, align: "right", format: "currency" },
            { key: "advance_amount", label: "Tạm ứng", minWidth: 140, align: "center", format: "currency", editable: true },
            { key: "reduction_other", label: "Khoản giảm trừ khác", minWidth: 160, align: "center", format: "currency", editable: true },
          ],
        },
        {
          key: "total_income",
          label: "Tổng lương thực nhận",
          minWidth: 100,
          align: "right",
          format: "currency",
        },
      ];

      return sections
        .map((section) => {
          if (section.children) {
            const children = section.children.filter((child) => selectedColumnSet.has(child.key));
            return children.length ? { ...section, children } : null;
          }
          return selectedColumnSet.has(section.key) ? section : null;
        })
        .filter(Boolean);
    },

    effectiveReportTypes() {
      if (this.exportConfig.report_selection_mode === "all") {
        return this.reportOptions.map((item) => item.value);
      }
      return this.exportConfig.report_types || [];
    },

  },

  watch: {
    visibleSalaryCompanyColumns() {
      this.scheduleSalaryCompanyTableLayout();
    },
  },

  methods: {
    getDefaultSalaryCompanyDisplayColumns() {
      return [...this.allSalaryCompanyDisplayColumnKeys];
    },

    getSavedSalaryCompanyDisplayColumns(defaultDisplayColumns) {
      if (typeof window === "undefined" || !window.localStorage) {
        return [...defaultDisplayColumns];
      }

      try {
        const savedValue = window.localStorage.getItem(SALARY_COMPANY_DISPLAY_COLUMNS_STORAGE_KEY);
        if (savedValue === null) {
          return [...defaultDisplayColumns];
        }

        const savedColumns = JSON.parse(savedValue);
        if (!Array.isArray(savedColumns)) {
          return [...defaultDisplayColumns];
        }

        const validColumnSet = new Set(this.allSalaryCompanyDisplayColumnKeys);
        const migratedColumns = savedColumns.reduce((result, column) => {
          if (column === "ot_total") {
            return result.concat(["ot_150", "ot_200", "ot_300"]);
          }
          result.push(column);
          return result;
        }, []);
        if (!migratedColumns.includes("meal_allowance_day")) {
          const insertIndex = migratedColumns.indexOf("actual_work");
          migratedColumns.splice(insertIndex >= 0 ? insertIndex + 1 : migratedColumns.length, 0, "meal_allowance_day");
        }
        if (!migratedColumns.includes("insurance_salary")) {
          const insertIndex = migratedColumns.indexOf("salary_level");
          migratedColumns.splice(insertIndex >= 0 ? insertIndex + 1 : migratedColumns.length, 0, "insurance_salary");
        }
        if (!migratedColumns.includes("meal_deduction")) {
          const insertIndex = migratedColumns.indexOf("tax_amount");
          migratedColumns.splice(insertIndex >= 0 ? insertIndex + 1 : migratedColumns.length, 0, "meal_deduction");
        }

        return [...new Set(migratedColumns)].filter((column) => validColumnSet.has(column));
      } catch (error) {
        void error;
        return [...defaultDisplayColumns];
      }
    },

    saveSalaryCompanyDisplayColumns(columns) {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }

      try {
        window.localStorage.setItem(
          SALARY_COMPANY_DISPLAY_COLUMNS_STORAGE_KEY,
          JSON.stringify(columns || [])
        );
      } catch (error) {
        void error;
      }
    },

    handleDisplayColumnSelectionChange(columns) {
      const nextColumns = [...(columns || [])];
      this.saveSalaryCompanyDisplayColumns(nextColumns);

      if (this.displayColumnApplyTimer) {
        clearTimeout(this.displayColumnApplyTimer);
      }

      this.displayColumnApplyTimer = setTimeout(() => {
        this.visibleSalaryCompanyColumns = [...nextColumns];
        this.displayColumnApplyTimer = null;
      }, 0);
    },

    scheduleSalaryCompanyTableLayout(delay = 0) {
      if (this.salaryCompanyTableLayoutTimer) {
        clearTimeout(this.salaryCompanyTableLayoutTimer);
        this.salaryCompanyTableLayoutTimer = null;
      }

      const runLayout = () => {
        this.$nextTick(() => {
          if (this.$refs.salaryCompanyMainTable && this.$refs.salaryCompanyMainTable.doLayout) {
            this.$refs.salaryCompanyMainTable.doLayout();
          }
        });
      };

      if (delay > 0) {
        this.salaryCompanyTableLayoutTimer = setTimeout(runLayout, delay);
        return;
      }

      if (typeof window !== "undefined" && window.requestAnimationFrame) {
        window.requestAnimationFrame(runLayout);
        return;
      }

      runLayout();
    },

    toggleSearchBox() {
      const nextValue = !this.showSearchBox;
      this.showSearchBox = nextValue;
      this.scheduleSalaryCompanyTableLayout(nextValue ? 380 : 0);
    },

    toggleDisplayColumnSelector() {
      this.showDisplayColumnSelector = !this.showDisplayColumnSelector;
    },

    handleDisplayColumnOutsideClick(event) {
      if (!this.showDisplayColumnSelector) {
        return;
      }
      const triggerEl = this.$refs.displayColumnTrigger;
      if (triggerEl && !triggerEl.contains(event.target)) {
        this.showDisplayColumnSelector = false;
      }
    },

    async fn_initDataDefault() {
      const companyInfo = MethodService.getCompanyInfo();
      const [
        salaryPeriodApiRes,
        branchApiRes,
        departmentApiRes,
        companyScopeRes,
        companyApiRes,
        positionApiRes,
        contractTypeApiRes,
      ] = await Promise.all([
        SalaryPeriodApi.GetWorksheetSalaryPeriodOptions({ limit: 100 }),
        BranchApi.list({ limit: 1000000 }, true),
        DepartmentApi.list({ limit: 1000000 }, true),
        CompanyApi.GetCompanyFilterOptions({}, true),
        CompanyApi.list({ limit: 1000000 }, true),
        PositionApi.list({ limit: 1000000 }, true),
        ContractTypeApi.list({ limit: 1000000, filters: "disabled!=true" }, true),
      ]);

      const scopedCompaniesFromFilter =
        companyScopeRes.result &&
        Array.isArray(companyScopeRes.result.companies) &&
        companyScopeRes.result.companies.length > 0
          ? companyScopeRes.result.companies
          : companyInfo && companyInfo.id
          ? [companyInfo]
          : [];
      const scopedCompaniesFromTree = this.fn_getCompanyTreeScope(
        companyApiRes.result || [],
        companyInfo && companyInfo.id ? companyInfo.id : undefined
      );
      const companyScopeCompanies = this.fn_mergeCompanyScope(
        scopedCompaniesFromFilter,
        scopedCompaniesFromTree
      );
      const companyScopeIds = companyScopeCompanies.map((item) => item.id).filter(Boolean);

      this.mData.dataDefault.listCompany = companyScopeCompanies;
      this.mData.dataDefault.listBranch = (branchApiRes.result || []).filter((item) => {
        return companyScopeIds.length === 0 || companyScopeIds.includes(item.company_id);
      });
      this.mData.dataDefault.listDepartment = (departmentApiRes.result || []).filter((item) => {
        return companyScopeIds.length === 0 || companyScopeIds.includes(item.company_id);
      });
      this.mData.dataDefault.listSalaryPeriod = salaryPeriodApiRes.result || [];
      this.mData.dataDefault.listPosition = positionApiRes.result || [];
      this.mData.dataDefault.listContractType = contractTypeApiRes.result || [];

      this.mData.dataDefault.listSalaryPeriod.sort((a, b) => {
        return new Date(b.from_date).getTime() - new Date(a.from_date).getTime();
      });

      const currentSalaryPeriods = this.mData.dataDefault.listSalaryPeriod.filter((item) => {
        return (
          new Date(item.from_date).getTime() <= new Date().getTime() &&
          new Date().getTime() < new Date(item.before_to_date).getTime()
        );
      });

      if (this.$route.query.salaryPeriodId) {
        this.selected_salary_period_id = this.$route.query.salaryPeriodId;
      } else if (currentSalaryPeriods.length > 0) {
        this.selected_salary_period_id = currentSalaryPeriods[0].id;
      } else if (this.mData.dataDefault.listSalaryPeriod.length > 0) {
        this.selected_salary_period_id = this.mData.dataDefault.listSalaryPeriod[0].id;
      }
    },

    fn_getCompanyTreeScope(companies = [], rootCompanyId) {
      const companyMap = new Map();
      companies.forEach((item) => {
        if (item && item.id) {
          companyMap.set(item.id, item);
        }
      });
      const scope = [];
      const visited = new Set();
      const stack = [rootCompanyId];
      while (stack.length > 0) {
        const currentId = stack.pop();
        if (!currentId || visited.has(currentId)) {
          continue;
        }
        visited.add(currentId);
        const currentCompany = companyMap.get(currentId);
        if (currentCompany) {
          scope.push(currentCompany);
        }
        companies.forEach((item) => {
          if (item && item.parent_company_id === currentId && !visited.has(item.id)) {
            stack.push(item.id);
          }
        });
      }
      return scope;
    },

    fn_mergeCompanyScope(primaryCompanies = [], fallbackCompanies = []) {
      const companyMap = new Map();
      [...primaryCompanies, ...fallbackCompanies].forEach((item) => {
        if (item && item.id && !companyMap.has(item.id)) {
          companyMap.set(item.id, item);
        }
      });
      return Array.from(companyMap.values());
    },

    getCompanyName(item) {
      if (!item || !item.name) {
        return "";
      }
        return item.name.name_vi || item.name.abbreviation_name || item.name;
    },

    getNullableNumberValue(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const numericValue = Number(String(value).replace(/,/g, ""));
      return isNaN(numericValue) ? "" : numericValue;
    },

    getPayrollExportValue(row, key, fallbackValue) {
      const value = row ? row[key] : undefined;
      return value === undefined || value === null || value === "" ? fallbackValue : value;
    },

    normalizeId(value) {
      if (value === undefined || value === null) {
        return "";
      }
      if (typeof value === "object" && value.$oid) {
        return String(value.$oid);
      }
      return String(value);
    },

    getRecordSortTime(item) {
      return new Date(item && (item.updated_at || item.created_at || 0)).getTime();
    },

    pickPreferredRecord(currentItem, nextItem) {
      if (!currentItem) {
        return nextItem;
      }
      const currentTime = this.getRecordSortTime(currentItem);
      const nextTime = this.getRecordSortTime(nextItem);
      if (nextTime > currentTime) {
        return nextItem;
      }
      if (nextTime < currentTime) {
        return currentItem;
      }
      return this.normalizeId(nextItem && nextItem.id) >
        this.normalizeId(currentItem && currentItem.id)
        ? nextItem
        : currentItem;
    },

    dedupeBy(items = [], getKey) {
      const recordMap = new Map();
      items.forEach((item) => {
        const key = getKey(item);
        if (!key) {
          return;
        }
        recordMap.set(key, this.pickPreferredRecord(recordMap.get(key), item));
      });
      return Array.from(recordMap.values());
    },

    fn_getCompanyScopeIds() {
      const scopeCompanies = this.mData.dataDefault.listCompany || [];
      if (this.search_company_id) {
        return [this.search_company_id];
      }
      if (scopeCompanies.length > 0) {
        return scopeCompanies.map((item) => item.id).filter(Boolean);
      }
      const currentCompanyId =
        this.mData.dataDefault.currentCompanyInfo &&
        this.mData.dataDefault.currentCompanyInfo.id
          ? this.mData.dataDefault.currentCompanyInfo.id
          : undefined;
      return currentCompanyId ? [currentCompanyId] : [];
    },

    async fn_applyCompanyDependentOptions() {
      const query = { limit: 1000000, feature_code: "FT2305" };
      if (this.search_company_id) {
        query.filters = `company_id=${this.search_company_id}`;
      }
      const [branchRes, departmentRes] = await Promise.all([
        BranchApi.list(query, true),
        DepartmentApi.list(query, true),
      ]);
      const branchOptions = branchRes.result || [];
      const departmentOptions = departmentRes.result || [];
      const branchOptionIds = branchOptions.map((item) => item.id);
      const departmentOptionIds = departmentOptions.map((item) => item.id);
      this.mData.dataDefault.listBranch = branchOptions;
      this.mData.dataDefault.listDepartment = departmentOptions;
      this.search_branch_ids = (this.search_branch_ids || []).filter((id) => {
        return branchOptionIds.includes(id);
      });
      this.search_department_ids = (this.search_department_ids || []).filter((id) => {
        return departmentOptionIds.includes(id);
      });
    },

    async fn_handleCompanyFilterChange() {
      await this.fn_applyCompanyDependentOptions();
    },

    fn_getSelectedSalaryPeriod() {
      return (
        (this.mData.dataDefault.listSalaryPeriod || []).find((item) => {
          if (!item) {
            return false;
          }
          if (item.id === this.selected_salary_period_id) {
            return true;
          }
          return (
            Array.isArray(item.salary_period_ids) &&
            item.salary_period_ids.includes(this.selected_salary_period_id)
          );
        }) || null
      );
    },

    fn_getSalaryPeriodIds(companyIds = []) {
      const selectedSalaryPeriod = this.fn_getSelectedSalaryPeriod();
      if (!selectedSalaryPeriod) {
        return this.selected_salary_period_id ? [this.selected_salary_period_id] : [];
      }

      const allSalaryPeriodIds = Array.isArray(selectedSalaryPeriod.salary_period_ids)
        ? selectedSalaryPeriod.salary_period_ids.filter(Boolean)
        : [];
      const salaryPeriodIdsByCompany = selectedSalaryPeriod.salary_period_ids_by_company || {};
      const scopedSalaryPeriodIds = (companyIds || [])
        .map((companyId) => salaryPeriodIdsByCompany[companyId])
        .filter(Boolean);

      if (scopedSalaryPeriodIds.length > 0) {
        return [...new Set(scopedSalaryPeriodIds)];
      }
      if (allSalaryPeriodIds.length > 0) {
        return [...new Set(allSalaryPeriodIds)];
      }
      return selectedSalaryPeriod.id ? [selectedSalaryPeriod.id] : [];
    },

    getCurrentSelectedPeriodInfo() {
      return (this.mData.dataDefault.listSalaryPeriod || []).find((item) => {
        return item.id === this.selected_salary_period_id;
      }) || this.fn_getSelectedSalaryPeriod() || {};
    },

    getExportPeriodName() {
      const period = this.getCurrentSelectedPeriodInfo();
      return period && period.name ? period.name : "";
    },

    getExportMetaText() {
      const companyName = this.search_company_id
        ? this.getCompanyName(
            (this.mData.dataDefault.listCompany || []).find((item) => {
              return item.id === this.search_company_id;
            })
          )
        : "Tất cả công ty";
      const departmentNames = (this.mData.dataDefault.listDepartment || [])
        .filter((item) => this.search_department_ids.includes(item.id))
        .map((item) => item.name)
        .filter(Boolean);
      const branchNames = (this.mData.dataDefault.listBranch || [])
        .filter((item) => this.search_branch_ids.includes(item.id))
        .map((item) => item.name)
        .filter(Boolean);
      const statusName = (this.mData.dataDefault.listTrangThaiLamViec || []).find((item) => {
        return item.value === this.search_employee_status;
      });
      return [
        `Kỳ lương: ${this.getExportPeriodName() || ""}`,
        `Công ty: ${companyName || "Tất cả công ty"}`,
        `Phòng ban: ${departmentNames.length ? departmentNames.join(", ") : "Tất cả phòng ban"}`,
        `Chi nhánh: ${branchNames.length ? branchNames.join(", ") : "Tất cả chi nhánh"}`,
        `Loại hợp đồng: ${this.getSelectedContractTypeNames()}`,
        `Trạng thái: ${statusName && statusName.label ? statusName.label : "Tất cả trạng thái"}`,
      ].join(" | ");
    },

    getSelectedContractTypeNames() {
      const contractTypeNames = (this.mData.dataDefault.listContractType || [])
        .filter((item) => this.search_contract_type_ids.includes(item.id))
        .map((item) => item.name)
        .filter(Boolean);
      return contractTypeNames.length ? contractTypeNames.join(", ") : "Tất cả loại hợp đồng";
    },

    getRawRecordMaps() {
      return {
        salaryMap: new Map(
          this.dedupeBy(this.mData.exportSource.salaryList || [], (item) => {
            return this.normalizeId(item.employee_id);
          }).map((item) => [this.normalizeId(item.employee_id), item])
        ),
        taxMap: new Map(
          this.dedupeBy(this.mData.exportSource.taxList || [], (item) => {
            return this.normalizeId(item.employee_id);
          }).map((item) => [this.normalizeId(item.employee_id), item])
        ),
        insuranceMap: new Map(
          this.dedupeBy(this.mData.exportSource.insuranceList || [], (item) => {
            return this.normalizeId(item.employee_id);
          }).map((item) => [this.normalizeId(item.employee_id), item])
        ),
      };
    },

    getSalaryCustomFieldValue(salary, aliases = []) {
      return this.getCustomFieldValue(
        salary && salary.custom_fields ? salary.custom_fields : [],
        aliases
      );
    },

    getCompanyPayrollInputFieldValue(salary, aliases = []) {
      const customFields = Array.isArray(salary && salary.custom_fields)
        ? salary.custom_fields
        : [];
      const normalize = (value) =>
        MethodService.changeAlias(`${value || ""}`)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");
      const aliasSet = new Set(aliases.map((item) => normalize(item)).filter(Boolean));
      const field = customFields.find((item) => {
        const isUserInput = item && (item.user_input === true || item.User_input === true);
        return isUserInput && aliasSet.has(normalize(item.key));
      });
      return field ? field.value : undefined;
    },

    isEditableSalaryCompanyColumn(column, row = null) {
      const isRowSealed = row && row.is_sealed === true;
      return !this.isPayrollSealed && !isRowSealed && column && SALARY_COMPANY_EDITABLE_COLUMN_KEYS.includes(column.key);
    },

    getEditableSalaryCompanyInputValue(row, column) {
      if (!row || !column) {
        return "";
      }
      const value = row[column.key];
      return this.formatEditableSalaryCompanyInputValue(value);
    },

    formatEditableSalaryCompanyInputValue(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const numericValue = this.parseEditableSalaryCompanyValue(value);
      return Number.isFinite(numericValue) ? numericValue.toLocaleString("en-US") : "";
    },

    parseEditableSalaryCompanyValue(value) {
      if (value === undefined || value === null || value === "") {
        return 0;
      }
      const normalizedValue = `${value}`.replace(/[,.]/g, "").trim();
      const numericValue = Number(normalizedValue);
      return Number.isFinite(numericValue) ? numericValue : 0;
    },

    handleEditableSalaryCompanyInput(row, column, value) {
      if (this.isPayrollSealed || !row || !column) {
        return;
      }
      if (value === undefined || value === null || value === "") {
        this.$set(row, column.key, "");
        this.updateSalaryCompanyRowTotal(row);
        return;
      }
      const numericValue = this.parseEditableSalaryCompanyValue(value);
      this.$set(row, column.key, this.formatEditableSalaryCompanyInputValue(numericValue));
      this.updateSalaryCompanyRowTotal(row);
    },

    rememberEditableSalaryCompanyFieldValue(row, column) {
      if (this.isPayrollSealed || !row || !column) {
        return;
      }
      const numericValue = this.parseEditableSalaryCompanyValue(row[column.key]);
      const originalValues = row._editableOriginalValues || {};
      this.$set(row, "_editableOriginalValues", {
        ...originalValues,
        [column.key]: numericValue,
      });
      if (numericValue === 0) {
        this.$set(row, column.key, "");
      }
    },

    updateSalaryCompanyRowTotal(row) {
      if (!row) {
        return;
      }
      const totalIncome =
        this.getNumberValue(row.salary_income) -
        this.getNumberValue(row.insurance_total) -
        this.getNumberValue(row.tax_amount) -
        this.getNumberValue(row.meal_deduction) -
        this.parseEditableSalaryCompanyValue(row.reduction_other) -
        this.parseEditableSalaryCompanyValue(row.advance_amount) +
        this.getNumberValue(row.meal_allowance) +
        this.parseEditableSalaryCompanyValue(row.bonus);
      this.$set(row, "total_income", Math.max(0, Math.round(totalIncome)));
    },

    getSalaryRecordByRow(row) {
      if (!row) {
        return null;
      }
      const salaryId = this.normalizeId(row.id);
      const employeeId = this.normalizeId(row.employee_id);
      const salaryPeriodId = this.normalizeId(row.salary_period_id || this.selected_salary_period_id);
      return (this.mData.exportSource.salaryList || []).find((item) => {
        const isSameEmployee = employeeId && this.normalizeId(item.employee_id) === employeeId;
        const isSameSalaryPeriod =
          salaryPeriodId && this.normalizeId(item.salary_period_id) === salaryPeriodId;
        return (
          (salaryId && this.normalizeId(item.id) === salaryId) ||
          (isSameEmployee && isSameSalaryPeriod)
        );
      }) || null;
    },

    buildEditableSalaryCustomFields(salary, columnKey, value) {
      const aliases = SALARY_COMPANY_EDITABLE_FIELD_ALIASES[columnKey] || [];
      const customFields = Array.isArray(salary && salary.custom_fields)
        ? salary.custom_fields.map((item) => ({ ...item }))
        : [];
      const normalize = (text) =>
        MethodService.changeAlias(`${text || ""}`)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");
      const aliasSet = aliases.map((item) => normalize(item));
      const foundIndex = customFields.findIndex((field) => {
        const key = normalize(field && field.key);
        return aliasSet.some((alias) => key === alias || key.includes(alias) || alias.includes(key));
      });
      const nextField = {
        key: columnKey,
        value: `${value}`,
        user_input: true,
      };

      if (foundIndex >= 0) {
        customFields.splice(foundIndex, 1, {
          ...customFields[foundIndex],
          ...nextField,
        });
      } else {
        customFields.push(nextField);
      }
      return customFields;
    },

    async saveEditableSalaryCompanyField(row, column) {
      if (!row || !this.isEditableSalaryCompanyColumn(column, row)) {
        return;
      }
      if (this.isPayrollSealed) {
        if (window.toastr) {
          window.toastr.warning("Bảng lương đã chốt, không thể cập nhật.");
        }
        return;
      }
      const salary = this.getSalaryRecordByRow(row) || {};
      if (!salary.id && (!row.employee_id || !row.salary_period_id)) {
        if (window.toastr) {
          window.toastr.warning("Không tìm thấy bản ghi lương để cập nhật.");
        }
        return;
      }

      const numericValue = this.parseEditableSalaryCompanyValue(row[column.key]);
      this.$set(row, column.key, numericValue);
      this.updateSalaryCompanyRowTotal(row);

      const originalValue =
        row._editableOriginalValues && row._editableOriginalValues[column.key] !== undefined
          ? row._editableOriginalValues[column.key]
          : undefined;
      if (originalValue === numericValue) {
        return;
      }

      const customFields = this.buildEditableSalaryCustomFields(salary, column.key, numericValue);
      const selectedPeriod = this.getCurrentSelectedPeriodInfo();
      const updatePayload = {
        custom_fields: customFields,
        total_income: this.getNumberValue(row.total_income),
      };
      const payload = salary.id ? {
        id: salary.id,
        ...updatePayload,
      } : {
        employee_id: salary.employee_id || row.employee_id,
        employee_no: salary.employee_no || row.employee_no || "",
        company_id: salary.company_id || row.company_id,
        company_name: salary.company_name || "",
        salary_period_id: salary.salary_period_id || row.salary_period_id,
        salary_period_name:
          salary.salary_period_name ||
          row.salary_period_name ||
          (selectedPeriod && selectedPeriod.name) ||
          "",
        ...updatePayload,
        headers: salary.headers || [],
        sealed: salary.sealed === true,
        disabled: salary.disabled === true,
      };

      try {
        const response = payload.id
          ? await SalaryApi.UpdateCompanyPayrollField(payload)
          : await SalaryApi.create(payload);
        const savedSalary = response && response.result ? response.result : payload;
        if (savedSalary && savedSalary.id && !salary.id) {
          this.$set(row, "id", savedSalary.id);
          this.mData.exportSource.salaryList.push(savedSalary);
        } else {
          salary.custom_fields = customFields;
          salary.total_income = payload.total_income;
        }
      } catch (error) {
        console.error("Update salary field failed", error);
        if (originalValue !== undefined) {
          this.$set(row, column.key, originalValue);
          this.updateSalaryCompanyRowTotal(row);
        }
        if (window.toastr) {
          window.toastr.error("Không cập nhật được dữ liệu lương.");
        }
      }
    },

    async confirmSealCompanyPayroll() {
      if (!this.selected_salary_period_id || this.isPayrollSealed) {
        return;
      }

      try {
        await this.$confirm(
          "Sau khi chốt, bảng lương sẽ không thể chỉnh sửa. Bạn có chắc chắn muốn chốt bảng lương này không?",
          "Xác nhận",
          {
            confirmButtonText: "Chốt bảng lương",
            cancelButtonText: "Hủy",
            type: "warning",
          }
        );
      } catch (error) {
        void error;
        return;
      }

      try {
        this.loading = true;
        const companyScopeIds = this.fn_getCompanyScopeIds();
        const salaryPeriodIds = this.fn_getSalaryPeriodIds(companyScopeIds);
        const response = await SalaryApi.SealCompanyPayroll({
          salary_period_id: this.selected_salary_period_id,
          salary_period_ids: salaryPeriodIds,
          company_id: this.search_company_id,
        });
        const result = response && response.result ? response.result : {};
        this.payrollStatus = {
          isSealed: result.is_sealed === true,
          sealedStatus: result.sealed_status || "APPROVED",
        };
        await this.fn_search();
        if (window.toastr) {
          window.toastr.success("Chốt bảng lương thành công.");
        }
      } catch (error) {
        console.error("SealCompanyPayroll failed", error);
        if (window.toastr) {
          window.toastr.error("Không chốt được bảng lương.");
        }
      } finally {
        this.loading = false;
      }
    },

    buildSalaryImportExportRows() {
      const { salaryMap, taxMap, insuranceMap } = this.getRawRecordMaps();
      return (this.mData.tableRules.data || []).map((row) => {
        const employeeId = this.normalizeId(row.employee_id);
        const salary = salaryMap.get(employeeId) || {};
        const tax = taxMap.get(employeeId) || {};
        const insurance = insuranceMap.get(employeeId) || {};
        const compulsoryInsurance = this.getNumberValue(insurance.social_insurance) +
          this.getNumberValue(insurance.health_insurance) +
          this.getNumberValue(insurance.unemployment_insurance);
        return {
          employee_no: row.employee_no || "",
          last_name: row.employee_name || "",
          space0: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "salary_level",
              this.getSalaryCustomFieldValue(salary, ["Lương cơ bản", "Lương", "Basic salary"])
            )
          ),
          actual_salary: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "salary_income",
              this.getSalaryCustomFieldValue(salary, ["Lương cơ bản", "Lương", "Basic salary"])
            )
          ),
          space1: this.getNullableNumberValue(
            this.getSalaryCustomFieldValue(salary, ["Phụ cấp trách nhiệm"])
          ),
          space2: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "meal_allowance",
              this.getSalaryCustomFieldValue(salary, ["Phụ cấp ăn trưa", "Tiền ăn", "Ăn trưa"])
            )
          ),
          space3: this.getNullableNumberValue(
            this.getSalaryCustomFieldValue(salary, ["Phụ cấp điện thoại"])
          ),
          space4: this.getNullableNumberValue(
            this.getSalaryCustomFieldValue(salary, ["Phụ cấp xăng xe"])
          ),
          space5: this.getNullableNumberValue(
            this.getSalaryCustomFieldValue(salary, ["Phụ cấp"])
          ),
          space6: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "bonus",
              this.getSalaryCustomFieldValue(salary, ["bonus", "Thưởng tháng", "Thưởng", "Bonus"])
            )
          ),
          space7: this.getNullableNumberValue(
            this.getSalaryCustomFieldValue(salary, ["Phụ cấp thâm niên"])
          ),
          space8: this.getNullableNumberValue(
            this.getPayrollExportValue(row, "social_insurance", insurance.social_insurance)
          ),
          space9: this.getNullableNumberValue(
            this.getPayrollExportValue(row, "health_insurance", insurance.health_insurance)
          ),
          space10: this.getNullableNumberValue(
            this.getPayrollExportValue(row, "unemployment_insurance", insurance.unemployment_insurance)
          ),
          space11: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "insurance_total",
              compulsoryInsurance ? compulsoryInsurance : ""
            )
          ),
          space12: this.getNullableNumberValue(
            this.getPayrollExportValue(row, "tax_amount", tax.income_tax)
          ),
          space13: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "advance_amount",
              this.getSalaryCustomFieldValue(salary, ["advance_amount", "Tạm ứng", "Advance"])
            )
          ),
          space14: this.getNullableNumberValue(
            this.getPayrollExportValue(
              row,
              "reduction_other",
              this.getCompanyPayrollInputFieldValue(salary, [
                "reduction_other",
                "Khoản giảm trừ khác",
                "Reduction other"
              ])
            )
          ),
          space15: this.getNullableNumberValue(
            this.getPayrollExportValue(row, "total_income", salary.total_income)
          ),
        };
      });
    },

    buildTaxImportExportRows() {
      const { taxMap } = this.getRawRecordMaps();
      return (this.mData.tableRules.data || []).map((row) => {
        const tax = taxMap.get(this.normalizeId(row.employee_id)) || {};
        return {
          employee_no: row.employee_no || "",
          last_name: row.employee_name || "",
          space0: this.getNullableNumberValue(row.taxable_income),
          space1: this.getNullableNumberValue(tax.family_allowances),
          space2: this.getNullableNumberValue(tax.donate),
          space3: this.getNullableNumberValue(tax.compulsory_insurance),
          space4: this.getNullableNumberValue(row.taxable_income),
          space5: this.getNullableNumberValue(tax.reduction_rate),
        };
      });
    },

    buildInsuranceImportExportRows() {
      const { insuranceMap } = this.getRawRecordMaps();
      return (this.mData.tableRules.data || []).map((row) => {
        const insurance = insuranceMap.get(this.normalizeId(row.employee_id)) || {};
        return {
          employee_no: row.employee_no || "",
          last_name: row.employee_name || "",
          space0: this.getNullableNumberValue(row.insurance_total),
          space1: this.getNullableNumberValue(insurance.health_insurance),
          space2: this.getNullableNumberValue(insurance.unemployment_insurance),
        };
      });
    },

    openExportDialog() {
      this.exportConfig.report_selection_mode = "all";
      this.exportConfig.format = "excel";
      this.exportConfig.word_orientation = "landscape";
      this.exportConfig.report_types = ["salary_company"];
      this.syncDialogExport = true;
    },

    exportSingleReport(type, format, options) {
      const periodName = options.periodName;
      const metaText = options.metaText;
      const wordOrientation = options.wordOrientation;
      const selectedColumns = options.selectedColumns || [];
      if (type === "salary_company") {
        if (format === "excel") {
          MethodService.exportSalaryCompanyExcelByColumns(this.mData.tableRules.data, {
            periodName,
            metaText,
            selectedColumns,
          });
          return;
        }
        MethodService.exportSalaryCompanyWordByColumns(this.mData.tableRules.data, {
          periodName,
          metaText,
          wordOrientation,
          selectedColumns,
        });
        return;
      }

      if (type === "salary_data") {
        const rows = this.buildSalaryImportExportRows();
        if (format === "excel") {
          MethodService.exportSalaryImportData(rows, { periodName, metaText });
          return;
        }
        MethodService.exportSalaryImportDataWord(rows, {
          periodName,
          metaText,
          wordOrientation,
        });
        return;
      }

      if (type === "tax_data") {
        const rows = this.buildTaxImportExportRows();
        if (format === "excel") {
          MethodService.exportTaxImportData(rows, { periodName, metaText });
          return;
        }
        MethodService.exportTaxImportDataWord(rows, {
          periodName,
          metaText,
          wordOrientation,
        });
        return;
      }

      if (type === "insurance_data") {
        const rows = this.buildInsuranceImportExportRows();
        if (format === "excel") {
          MethodService.exportInsuranceImportData(rows, { periodName, metaText });
          return;
        }
        MethodService.exportInsuranceImportDataWord(rows, {
          periodName,
          metaText,
          wordOrientation,
        });
      }
    },

    async confirmExport() {
      if (!this.effectiveReportTypes.length) {
        window.toastr.warning("Vui lòng chọn ít nhất 1 loại dữ liệu để xuất");
        return;
      }
      try {
        this.loading = true;
        await this.fn_search();
        if (!(this.mData.tableRules.data || []).length) {
          window.toastr.warning("Không có dữ liệu phù hợp để xuất");
          this.loading = false;
          return;
        }
        const options = {
          periodName: this.getExportPeriodName(),
          metaText: this.getExportMetaText(),
          wordOrientation: this.exportConfig.word_orientation,
          selectedColumns: this.currentSalaryCompanyExportColumnKeys,
        };
        this.effectiveReportTypes.forEach((type) => {
          this.exportSingleReport(type, this.exportConfig.format, options);
        });
        this.syncDialogExport = false;
        window.toastr.success("Xuất file thành công");
      } catch (error) {
        console.error(error);
        window.toastr.error("Có lỗi xảy ra khi xuất file");
      } finally {
        this.loading = false;
      }
    },

    getCustomFieldValue(customFields = [], aliases = []) {
      if (!Array.isArray(customFields) || customFields.length === 0) {
        return undefined;
      }

      const normalize = (value) =>
        MethodService.changeAlias(`${value || ""}`)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");

      const normalizedAliases = aliases.map((item) => normalize(item));

      const foundItem = customFields.find((field) => {
        const key = normalize(field.key);
        return normalizedAliases.some((alias) => {
          return key === alias || key.includes(alias) || alias.includes(key);
        });
      });

      return foundItem ? foundItem.value : undefined;
    },

    getNumberValue(value, defaultValue = 0) {
      if (value === undefined || value === null || value === "") {
        return defaultValue;
      }
      const numericValue = Number(String(value).replace(/,/g, ""));
      return isNaN(numericValue) ? defaultValue : numericValue;
    },

    getRoundedUnitValue(value, defaultValue = 0) {
      const numericValue = this.getNumberValue(value, defaultValue);
      return Math.round(numericValue);
    },

    async fn_search() {
      if (!this.selected_salary_period_id) {
        this.mData.exportSource = createEmptyPayrollExportSource();
        this.mData.tableRules.data = [];
        this.payrollStatus = {
          isSealed: false,
          sealedStatus: "NEW",
        };
        return;
      }

      const companyScopeIds = this.fn_getCompanyScopeIds();
      const salaryPeriodIds = this.fn_getSalaryPeriodIds(companyScopeIds);

      if (salaryPeriodIds.length === 0) {
        this.mData.exportSource = createEmptyPayrollExportSource();
        this.mData.tableRules.data = [];
        this.payrollStatus = {
          isSealed: false,
          sealedStatus: "NEW",
        };
        return;
      }

      try {
        this.loading = true;
        const payrollRes = await SalaryApi.GetCompanyPayroll({
          salary_period_id: this.selected_salary_period_id,
          salary_period_ids: salaryPeriodIds,
          company_id: this.search_company_id,
          department_ids: this.search_department_ids,
          branch_ids: this.search_branch_ids,
          contract_type_ids: this.search_contract_type_ids,
          employee_status: this.search_employee_status,
          condition: this.mData.tableRules.dataSearch.value.condition,
        });
        const payrollResult = payrollRes && payrollRes.result ? payrollRes.result : {};

        this.mData.exportSource = {
          salaryList: Array.isArray(payrollResult.salary_list) ? payrollResult.salary_list : [],
          taxList: Array.isArray(payrollResult.tax_list) ? payrollResult.tax_list : [],
          insuranceList: Array.isArray(payrollResult.insurance_list) ? payrollResult.insurance_list : [],
        };
        this.mData.tableRules.data = Array.isArray(payrollResult.rows) ? payrollResult.rows : [];
        this.payrollStatus = {
          isSealed: payrollResult.is_sealed === true,
          sealedStatus: payrollResult.sealed_status || "NEW",
        };
      } catch (error) {
        console.error("GetCompanyPayroll failed", error);
        this.mData.exportSource = createEmptyPayrollExportSource();
        this.mData.tableRules.data = [];
        this.payrollStatus = {
          isSealed: false,
          sealedStatus: "NEW",
        };
        if (window.toastr) {
          window.toastr.error("Không tải được dữ liệu bảng lương công ty.");
        }
      } finally {
        this.loading = false;
      }
    },

    formatCurrency(value) {
      return MethodService.formatCurrency(this.getRoundedUnitValue(value));
    },

    formatNumber(value) {
      const numericValue = this.getNumberValue(value);
      return numericValue ? MethodService.mathRound(numericValue) : 0;
    },

    formatSalaryCompanyPreviewValue(row, column) {
      const value = row[column.key];
      if (column.format === "currency") {
        return this.formatCurrency(value);
      }
      if (column.format === "number") {
        return this.formatNumber(value);
      }
      return value === null || value === undefined || value === "" ? "" : value;
    },

    formatSalaryCompanyMainValue(row, column, index) {
      if (column.key === "stt") {
        return index + 1;
      }
      return this.formatSalaryCompanyPreviewValue(row, column);
    },

    fn_getSalaryCompanyMainCellStyle({ column }) {
      const flattenColumns = this.salaryCompanyMainSections.reduce((result, section) => {
        if (section.children) {
          return result.concat(section.children);
        }
        result.push(section);
        return result;
      }, []);
      const targetColumn = flattenColumns.find((item) => item.key === column.property);
      if (targetColumn && targetColumn.editable) {
        return { textAlign: "center" };
      }
      if (targetColumn && targetColumn.align) {
        return { textAlign: targetColumn.align };
      }
      return { textAlign: "left" };
    },

    fn_getHeaderCellStyle() {
      return {
        textAlign: "center",
        background: "#ffa15c",
        color: "#fff",
        fontWeight: "700",
      };
    },
  },

  async mounted() {
    document.addEventListener("click", this.handleDisplayColumnOutsideClick);
    await this.fn_initDataDefault();
    await this.fn_applyCompanyDependentOptions();
    await this.fn_search();
    this.scheduleSalaryCompanyTableLayout(0);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleDisplayColumnOutsideClick);
    if (this.salaryCompanyTableLayoutTimer) {
      clearTimeout(this.salaryCompanyTableLayoutTimer);
      this.salaryCompanyTableLayoutTimer = null;
    }
    if (this.displayColumnApplyTimer) {
      clearTimeout(this.displayColumnApplyTimer);
      this.displayColumnApplyTimer = null;
    }
  },
};
</script>

<style scoped>
.salary_period {
  min-width: 230px;
}

.salary-company-toolbar-section {
  position: relative;
}

.salary-display-column-trigger {
  position: relative;
  display: inline-flex;
}

.salary-company-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 15px;
  margin-bottom: 12px;
}

.salary-company-header__main {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.salary-company-header__title {
  margin: 0;
  font-size: 22px;
  line-height: 1.3;
  color: #303133;
}

.salary-company-header__period {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.salary-company-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 34px;
  font-size: 16px;
  line-height: 1.3;
  white-space: nowrap;
}

.salary-company-status__label {
  color: #606266;
  font-weight: 400;
}

.salary-company-status__value {
  font-weight: 700;
}

.salary-company-status__value--sealed {
  color: #2e7d32;
}

.salary-company-status__value--open {
  color: #ff8f4f;
}

.salary-export-layout {
  display: block;
}

.salary-export-settings {
  width: 100%;
}

.export-report-select {
  width: 100%;
}

.export-hint {
  color: #606060;
  line-height: 1.5;
}

.salary-export-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

::v-deep .salary-export-dialog .el-dialog__header {
  padding: 18px 24px;
  background: #ffa15c;
}

::v-deep .salary-export-dialog .el-dialog__body {
  padding: 24px 24px 8px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

::v-deep .salary-export-dialog .el-dialog__footer {
  padding: 12px 24px 24px;
}

::v-deep .salary-export-dialog {
  max-height: calc(100vh - 40px);
}

::v-deep .salary-export-form .el-form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
}

::v-deep .salary-export-form .salary-export-form-item--center {
  align-items: center;
}

::v-deep .salary-export-form .salary-export-form-item--sub {
  margin-top: -8px;
  padding-left: 128px;
}

::v-deep .salary-export-form .salary-export-form-item--sub .el-form-item__label {
  visibility: hidden;
}

::v-deep .salary-export-form .salary-export-form-item--sub .el-form-item__content {
  width: 100%;
}

::v-deep .salary-export-form .el-form-item__label {
  float: none;
  flex: 0 0 128px;
  width: 128px !important;
  color: #404040;
  font-weight: 600;
  line-height: 22px;
  padding-right: 18px;
  text-align: left;
  white-space: normal;
}

::v-deep .salary-export-form .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
  line-height: normal;
}

::v-deep .salary-export-dialog .export-report-select .el-input__inner {
  height: 48px;
  line-height: 48px;
}

::v-deep .salary-export-dialog .export-report-select .el-select__tags {
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  left: 8px;
  max-width: calc(100% - 32px) !important;
}

::v-deep .salary-export-dialog .export-report-select .el-tag {
  margin: 0;
}

::v-deep .salary-export-dialog .export-report-select .el-select__tags-text {
  line-height: 24px;
}

::v-deep .salary-export-dialog .el-radio-group {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

::v-deep .salary-export-dialog .el-dialog__title,
::v-deep .salary-export-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .salary-company-table {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}

::v-deep .salary-company-table th > .cell {
  white-space: normal;
  line-height: 1.4;
  font-weight: 600;
  padding: 12px 8px;
}

::v-deep .salary-company-table .el-table__header-wrapper thead tr:first-child th:first-child {
  border-top-left-radius: 18px;
}

::v-deep .salary-company-table .el-table__header-wrapper thead tr:first-child th:last-child {
  border-top-right-radius: 18px;
}

::v-deep .salary-company-table .el-table__body td .cell {
  word-break: break-word;
  color: #606060;
}

::v-deep .salary-company-table .salary-company-edit-input .el-input__inner {
  width: 100%;
  padding: 0 14px;
  border: 1px solid #cfd8e3;
  border-radius: 12px;
  background: #ffffff;
  color: #606060;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
}

::v-deep .salary-company-table .salary-company-edit-input {
  width: 100%;
  max-width: 260px;
}

::v-deep .salary-company-table .salary-company-edit-input .el-input__inner:focus {
  border-color: #9fb5cc;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(159, 181, 204, 0.18);
}

::v-deep .salary-company-table .el-table__body tr:nth-child(2n) {
  background-color: #fafafa;
}

::v-deep .salary-company-table .el-table__fixed,
::v-deep .salary-company-table .el-table__fixed-right {
  box-shadow: none;
}

::v-deep .salary-company-table .el-table__fixed-header-wrapper thead tr th,
::v-deep .salary-company-table .el-table__fixed-body-wrapper tbody tr td {
  background-color: #fff;
}

::v-deep .salary-company-table .el-table__fixed-body-wrapper tbody tr:nth-child(2n) td {
  background-color: #fafafa;
}

.button-div {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.main-body-search {
  padding-right: 10px;
}

.main-body-search__content {
  padding-top: 12px;
  padding-bottom: 16px;
}

.salary-company-search-row {
  margin-bottom: 4px;
}

.salary-company-search-col {
  margin-bottom: 2px;
}

.salary-company-search-col .salary_period {
  width: 100%;
  min-width: 0;
}

::v-deep .salary-company-search-col .el-select {
  width: 100%;
}

::v-deep .salary-company-contract-type-form-item .el-form-item__label {
  white-space: nowrap;
}

::v-deep .salary-company-contract-type-select .el-select__tags {
  max-width: calc(100% - 38px) !important;
}

::v-deep .salary-company-contract-type-select .el-tag {
  max-width: 100%;
}

::v-deep .salary-company-contract-type-select .el-select__tags-text {
  display: inline-block;
  max-width: none;
  overflow: visible;
  text-overflow: clip;
  vertical-align: middle;
  white-space: nowrap;
}

::v-deep .salary-company-filter-select--all-placeholder .el-input__inner::placeholder,
::v-deep .salary-company-filter-select--all-placeholder .el-select__input::placeholder {
  color: #606266;
  opacity: 1;
}

.salary-display-column-dropdown {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 20;
  width: min(920px, calc(100vw - 60px));
  padding: 16px;
  border: 1px solid #f3d0b7;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(31, 41, 55, 0.16);
}

.salary-display-column-panel-wrap {
  display: flex;
  justify-content: stretch;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.salary-display-column-panel {
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.salary-display-column-panel__group {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
}

.salary-display-column-panel__item {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 0;
  padding: 10px 12px;
  border: 1px solid #c0ccd9;
  border-radius: 12px;
  background: #ffffff;
  color: #606266;
  box-sizing: border-box;
}

::v-deep .salary-display-column-panel__item .el-checkbox__label {
  flex: 1;
  padding-left: 10px;
  line-height: 1.45;
  white-space: normal;
  color: #606266;
}

::v-deep .salary-display-column-panel__item .el-checkbox__input {
  display: flex;
  align-items: center;
}

@media (max-width: 1220px) {
  .salary-company-header {
    flex-direction: column;
    align-items: stretch;
  }

  .button-div {
    margin-bottom: 10px;
    text-align: right;
    justify-content: flex-end;
  }

  .salary-company-header__main {
    flex-direction: column;
    align-items: flex-start;
  }

  .salary-display-column-dropdown {
    right: auto;
    left: 0;
    width: min(920px, calc(100vw - 48px));
  }

  .salary-display-column-panel-wrap {
    justify-content: stretch;
  }

  .salary-display-column-panel {
    width: 100%;
  }

  .salary-display-column-panel__group {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

}

@media (max-width: 768px) {
  .salary-display-column-panel__group {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .salary-display-column-panel__group {
    grid-template-columns: 1fr;
  }
}
</style>
